import React from 'react';
import { ShieldIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="mx-auto max-w-5xl px-4 py-12 md:py-14" data-id="element-91" data-mp="1o3x3nprb6w3l">
      <div className="flex flex-col items-center gap-5 rounded-3xl border-2 border-accent/30 bg-white p-6 text-center shadow-sm md:flex-row md:p-8 md:text-left" data-id="element-92" data-mp="1o5q1cfjy25zg">
        <span className="inline-flex shrink-0 rounded-full border-2 border-accent bg-canvas p-4" data-id="element-93" data-mp="1x5d5va7yzrwq">
          <ShieldIcon className="h-9 w-9 text-accent" data-id="element-94" data-mp="19fsimf4sa8hn" />
        </span>
        <div data-id="element-95" data-mp="14fxugjce7x0a">
          <h2 className="text-lg font-black uppercase text-ink md:text-xl" data-id="element-96" data-mp="14gfln1k77l1c">
            Garantía de 7 días, sin preguntas
          </h2>
          <p className="mt-2 text-sm font-semibold leading-relaxed text-slate-600" data-id="element-97" data-mp="1j654qbs8y9pw">
            Abrís los tomos, mirás las planificaciones y las usás. Si no es lo que esperabas,
            escribís a compradigitalyaa@gmail.com dentro de los 7 días y te devolvemos el 100% del
            pago. Sin formularios, sin drama.
          </p>
        </div>
      </div>
    </section>;
}